import { PropsWithChildren } from 'preact/compat';
import './ProductRelatedQuestionList.less';

export type ProductRelatedQuestionListProps = PropsWithChildren;

const ProductRelatedQuestionList = ({
    children
}: ProductRelatedQuestionListProps) => (
    <div className={`bri-ProductRelatedQuestionList`}>{children}</div>
);

export default ProductRelatedQuestionList;
